import React from "react";

import svg from "../../assets/images/icons/Form Controls/textarea.svg";

export const TextAreaIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Text Area"}
    />
);
